import * as React from "react"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { Check } from "lucide-react"

import { cn } from "@/lib/utils"

const Checkbox = React.forwardRef(({ className, size = "default", ...props }, ref) => {
  // Size variants
  const sizeClasses = {
    default: "h-4 w-4",
    sm: "h-3 w-3",
    xs: "h-2.5 w-2.5"
  };
  
  const checkSizes = {
    default: "h-3 w-3",
    sm: "h-2 w-2",
    xs: "h-1.5 w-1.5"
  };
  
  return (
    <CheckboxPrimitive.Root
      ref={ref}
      className={cn(
        "peer shrink-0 rounded-sm border border-primary shadow focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground",
        sizeClasses[size] || sizeClasses.default,
        className
      )}
      {...props}>
      <CheckboxPrimitive.Indicator className={cn("flex items-center justify-center text-current h-full w-full")}>
        <Check className={checkSizes[size] || checkSizes.default} strokeWidth={3} />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
});
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
